/* eslint-disable object-curly-newline */
/* eslint-disable camelcase */
import React from 'react';
import { Stack } from '@mui/material';
import HorizontalScrollBar from 'pages/wholeme/molecules/horizontalScrollBar/HorizontalScrollBar';

const WholeMeProfileExperienceRibbon = ({ experiences }) => (
  <Stack
    direction="row"
    sx={{
      whiteSpace: 'nowrap',
      'overflow-x': 'auto',
      'overflow-y': 'hidden',
    }}
  >
    <HorizontalScrollBar
      itemMeta={{
        experiences,
      }}
    />
  </Stack>
);

export default WholeMeProfileExperienceRibbon;
